/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Bystep_DescInputs */

const en_mk_team_bystep_desc = /** @type {(inputs: Mk_Team_Bystep_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run coding in the cloud with your Bystep plan. Start and monitor work directly from your browser.`)
};

const id_mk_team_bystep_desc = /** @type {(inputs: Mk_Team_Bystep_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalankan coding di cloud dengan paket Bystep. Mulai dan pantau pekerjaan langsung dari browser.`)
};

/**
* | output |
* | --- |
* | "Run coding in the cloud with your Bystep plan. Start and monitor work directly from your browser." |
*
* @param {Mk_Team_Bystep_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_bystep_desc = /** @type {((inputs?: Mk_Team_Bystep_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Bystep_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_bystep_desc(inputs)
	return en_mk_team_bystep_desc(inputs)
});